import React from 'react';
import { Box } from '@mui/system';

type Props = {
    quantity: number;
    onIncrement?: () => void;
    onDecrement?: () => void;
    showControl?: boolean;
    disabled?: boolean;
};

const QuantityControls: React.FC<Props> = ({ quantity, onIncrement, onDecrement, showControl = true, disabled = false }) => {
    if (!showControl) return null;

    return (
        <Box className={'flex items-center gap-1'}>
            <button
                disabled={disabled}
                onClick={onDecrement}
                className={`
                    rounded-full border border-gray-400 w-4 h-4
                    flex items-center justify-center p-0 relative
                    ${disabled ? 'text-gray-400 cursor-not-allowed' : 'hover:bg-gray-50'}
                    focus:outline-none
                `}
                aria-label={'Decrease quantity'}
            >
                <span className={'absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2'}>−</span>
            </button>

            <div
                className={`
                    rounded-full border border-gray-400 px-3
                    text-sm text-center
                    ${disabled ? 'text-gray-400' : ''}
                `}
            >
                {quantity}
            </div>

            <button
                disabled={disabled}
                onClick={onIncrement}
                className={`
                    rounded-full border border-gray-400 w-4 h-4
                    flex items-center justify-center p-0 relative
                    ${disabled ? 'text-gray-400 cursor-not-allowed' : 'hover:bg-gray-50'}
                    focus:outline-none
                `}
                aria-label={'Increase quantity'}
            >
                <span className={'absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2'}>+</span>
            </button>
        </Box>
    );
};

export default QuantityControls;
